import React from 'react'
import { compose } from 'recompose'
import { withFormik } from 'formik'
import { connect } from 'react-redux'

import GeneralInfoFormLocation from './GeneralInfoFormLocation'
import config from '../../../config'
import withLocation from '../../../modules/location/withLocation'
import { withPortalAutoRemoteSync } from '../../../modules/common/withPortalAutoRemoteSync'
import withValidateBeforeSync from '../../../modules/common/withValidateBeforeSync'

class GeneralInfoFormLocationContainer extends React.Component {
  handleBlur = event => {
    const { target: { name, value: _value } } = event
    if (name === 'latitude' || name === 'longtitude') {
      const value = parseFloat(_value)
      this.props.setFieldValue(name, value)
      this.props.handleAutoSync(name, value)
    } else {
      this.props.handleAutoSyncOnBlur(event)
    }
  }

  handleMarkerChange = ({ lat, lng }) => {
    this.props.handleAutoSync('longitude', lng)
    this.props.handleAutoSync('latitude', lat)
  }

  render() {
    return (
      <GeneralInfoFormLocation
        {...this.props}
        onBlur={this.handleBlur}
        onMarkerChange={this.handleMarkerChange}
      />
    )
  }
}

const initialInformation = (
  locationInfo,
  { coords: { latitude: systemLat = 0, longitude: systemLng = 0 } },
) => {
  let latitude = locationInfo && parseFloat(locationInfo.latitude)
  latitude = isNaN(latitude) ? systemLat : latitude

  let longitude = locationInfo && parseFloat(locationInfo.longitude)
  longitude = isNaN(longitude) ? systemLng : longitude
  
  return {
    streetAddress: config.getLangText(),
    ...locationInfo,
    latitude,
    longitude,
  }
}

const validateLocation = (values, { language }) => {
  let errors = {}
  return errors
}

export default compose(
  connect(({ portal, info: { language } }) => ({ portal, language })),
  withLocation,
  withFormik({
    mapPropsToValues: ({ portal: { location: locationInfo }, location }) => {
      return initialInformation(locationInfo, location)
    },
    validate: validateLocation,
    enableReinitialize: true,
    displayName: 'Location', // helps with React DevTools
  }),
  withPortalAutoRemoteSync(props => ({ path: `location` })),
  withValidateBeforeSync({
    validate: validateLocation,
  }),
)(GeneralInfoFormLocationContainer)



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoFormLocationContainer.js